import { render, staticRenderFns } from "./CardRoom2.vue?vue&type=template&id=4300d246&scoped=true"
import script from "./CardRoom2.vue?vue&type=script&lang=js"
export * from "./CardRoom2.vue?vue&type=script&lang=js"
import style0 from "./CardRoom2.vue?vue&type=style&index=0&id=4300d246&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4300d246",
  null
  
)

export default component.exports